"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetPurpose = void 0;
var AssetPurpose;
(function (AssetPurpose) {
    AssetPurpose[AssetPurpose["Gallery"] = 1] = "Gallery";
    AssetPurpose[AssetPurpose["HeroInLandingPage"] = 2] = "HeroInLandingPage";
    AssetPurpose[AssetPurpose["SubHeroInLandingPage"] = 4] = "SubHeroInLandingPage";
    AssetPurpose[AssetPurpose["HeroInDetailsPage"] = 8] = "HeroInDetailsPage";
    AssetPurpose[AssetPurpose["SubHeroInDetailsPage"] = 16] = "SubHeroInDetailsPage";
    AssetPurpose[AssetPurpose["SubHero2InDetailsPage"] = 32] = "SubHero2InDetailsPage"; // 2^5 = 32
})(AssetPurpose = exports.AssetPurpose || (exports.AssetPurpose = {}));
;
